import { useSearchParams } from 'react-router-dom';
import type { BetaSearchSort } from '../utils/betaSearchSort';
import { sortFromParam, withSortParam } from '../utils/feedsV2Sort';

/** The page's sort, kept in the URL's `sort` parameter (so a copied link keeps it), and its setter. */
export function useSortParam(): [BetaSearchSort, (sort: BetaSearchSort) => void] {
  const [params, setParams] = useSearchParams();
  return [sortFromParam(params.get('sort')), sort => setParams(prev => withSortParam(prev, sort), { replace: true })];
}
